import { canUseWindow } from '@/utils/browser'
import { setupChat } from './chat'
import {
  isAgentApp,
  isHelpDeskIFrame,
  isPublicVersion,
  isTestEnv,
  isBase,
  isDev,
} from './environment'
import auth from './auth'
import { initPostMessageListeners } from '@/utils/browser'
import { connection } from './postMessage'
import { PM_EVENT } from './postMessage/constants'

export const initRoutine = () => {
  if (canUseWindow) {
    if (isPublicVersion) {
      setupChat()
      auth.init()

      return
    }

    if (isAgentApp) {
      connection.init()
      connection.events.once(PM_EVENT.CREDENTIALS, ({ access_token }) => {
        auth.init(access_token)
      })

      if (isDev) {
        auth.init()
      }

      return
    }

    // TODO: Remove after HD rewrite
    if (isHelpDeskIFrame) {
      initPostMessageListeners()
      auth.init()

      return
    }

    if (isTestEnv || isBase) {
      auth.init()
    }
  }
}
